const enUS = require('./en-US');

module.exports = {
  taxId: 'HST #',
  ...enUS,
};
